import type { SolarPanelsProductOverviewState } from '../../store';

export const mockSolarPanelsProductOverviewViewModel: SolarPanelsProductOverviewState =
  {
    isVisible: true,
  };
